import { ThemeProperties } from '../../../core';

export interface InputCheckboxTheme {
	focusColor: string;
	labelMarginBottom: string;

	itemsGap: string;
	itemsMargin: string;
	itemsHorizontalGap: string;
	outlinedItemsGap: string;

	itemFont: string;
	itemTextColor: string;
	itemGap: string;

	subLabelFont: string;

	indicatorBackground: string;
	indicatorBorderColor: string;
	indicatorSize: string;

	activeIndicatorOutlineColor: string;

	checkedItemFont: string;
	checkedIndicatorBorderColor: string;
	checkedIndicatorBackground: string;

	outlinedItemPadding: string;
	outlinedItemMinHeight: string;
	outlinedItemBorderColor: string;
	outlinedItemBorderRadius: string;

	hoverOutlinedItemBorderColor: string;

	checkedOutlinedItemBackground: string;

	activeOutlinedItemOutlineColor: string;

	disabledOutlinedItemBackground: string;
	disabledIndicatorBorderColor: string;
	disabledIndicatorBackground: string;
}

export const theme = new ThemeProperties('inputCheckbox');
